/** Id prefixes linking each tab list with the `tabpanel` it controls (see `ui/components/tabIds`). */
export const MODE_TABS_PREFIX = 'mode';
export const BOTTOM_TABS_PREFIX = 'bottom';
